import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export { default as extend } from './extend';

// mySLP's institution, shown right under the username everywhere it
// appears: every post's author panel (PostUser), and the profile header /
// hover card shared by UserPage and post-author hovers (UserCard). Both
// components are lazily-loaded chunks in core, hence the string-path form
// of extend() (it defers via flarum.reg.onLoad instead of requiring an
// eagerly-awaited dynamic import).
function institution(user) {
  return user.slpInstitution?.() || '';
}
app.initializers.add('hli-oauth-slp-provider', () => {
  extend('flarum/forum/components/PostUser', 'userViewItems', function (items, user, _post) {
    const org = institution(user);
    if (org) {
      items.add('slpInstitution', m("p", {
        className: "PostUser-institution"
      }, org), 80);
    }
  });
  extend('flarum/forum/components/UserCard', 'infoItems', function (items) {
    // UserCard is shared by the profile page and the post-author hover
    // card; `this` is the component instance in both cases.
    const user = this.attrs.user;
    const org = institution(user);
    if (org) {
      items.add('slpInstitution', m("span", {
        className: "UserCard-institution"
      }, org), 95);
    }
  });
});